var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 10,
    fill: "#F0F5FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_373_6287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6663 40.0002H39.9997V30.6668C39.9997 28.8209 39.4523 27.0164 38.4267 25.4815C37.4012 23.9467 35.9435 22.7504 34.2381 22.044C32.5326 21.3375 30.656 21.1527 28.8455 21.5128C27.035 21.873 25.372 22.7619 24.0667 24.0672C22.7614 25.3725 21.8725 27.0355 21.5123 28.846C21.1522 30.6565 21.3371 32.5331 22.0435 34.2385C22.7499 35.944 23.9462 37.4017 25.481 38.4272C27.0159 39.4528 28.8204 40.0002 30.6663 40.0002ZM41.333 32.0002H31.9997V41.3335C31.9997 43.1795 32.5471 44.984 33.5726 46.5188C34.5982 48.0537 36.0559 49.25 37.7613 49.9564C39.4667 50.6628 41.3434 50.8476 43.1539 50.4875C44.9643 50.1274 46.6274 49.2385 47.9327 47.9332C49.238 46.6279 50.1269 44.9648 50.487 43.1543C50.8471 41.3439 50.6623 39.4672 49.9559 37.7618C49.2495 36.0563 48.0532 34.5987 46.5183 33.5731C44.9835 32.5476 43.179 32.0002 41.333 32.0002Z",
    stroke: "#54D4BD",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_373_6287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsConnect);
export default __webpack_public_path__ + "static/media/Icons-connect.a5737029d610929612b8c205466dc38c.svg";
export { ForwardRef as ReactComponent };